import styled from "styled-components/macro";
import colors from "../variables/colors";

export const FinderTopBar = styled.button`
  display: flex;
  flex: 0 0 100%;
  background-color: ${colors.blue.base};
  justify-content: space-between;
  align-items: center;
  padding: 0.833rem 0.833rem 0.833rem 1.666rem;
  min-width: 100%;
  color: ${colors.white.base};
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  text-align: left;
  h2 {
    font-weight: 700;
    font-size: 1.333rem;
  }
  span {
    font-size: 13px;
  }

  @media (min-width: 1024px) {
    padding: 1.111rem 30px 0.8333rem;
  }
`;

export default FinderTopBar;
